// libraries
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { OnboardingType } from "../saveSlider";
// saveSlider
import saveSlider from "../saveSlider.module.scss";

interface Props {
  type: OnboardingType;
}

const Second = ({ type = OnboardingType.LARGE }: Props) => {
  const { t } = useTranslation();
  return (
    <div className={saveSlider.container}>
      <div
        className={classNames(
          saveSlider.image_wrapper,
          type === OnboardingType.SMALL && saveSlider.image_wrapper_smaller
        )}>
        <img alt="img" src="/assets/images/slider/saveSlider2.png" />
      </div>
      <div
        className={classNames(
          saveSlider.text_wrapper,
          type === OnboardingType.SMALL && saveSlider.text_wrapper_smaller
        )}>
        <h2 className={classNames("centerAlign")}>
          {t("lbl_contract_slider_two_subtitle")}
          <span className={"primary"}>
            {t("lbl_contract_slider_two_title")}
          </span>
        </h2>
      </div>
    </div>
  );
};

export default Second;
